import React from "react";
import Buttons from "../button/Button";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import "./lmsFilterList.scss";
import commonImages from "../../../assets";
import { ACTIVE_INACTIVE, ORG_ID, USER_ID, GRID_DEFAULT_PAGE_SIZE } from "../../../constant/constant";
import SelectMenu from "../selectMenu/SelectMenu";
import { CardActions, Grid } from "@mui/material";
import Checkbox from "../../checkbox/checkbox";
import FormControl from "@mui/material/FormControl";
import FormLabels from "../formLabel/FormLabels";

const LmsFilterList = ({
  filterType,
  handleSearch,
  tabvalue,
  inputsearch,
  onChangeType,
  filter,
  selectedValue,
  isFilterTypeList = true,
  handleClear,
  setisTableLoading,
  activeInActive,
  statusCheckbox = false,
  handleActiveInActiveChange,
  isSafetyLog,
  usersId,
}) => {
  const handleApply = (e) => {
    const data = {
      pageNumber: 1,
      pageSize: GRID_DEFAULT_PAGE_SIZE,
      search: inputsearch ? inputsearch : "",
      catIds: isFilterTypeList
        ? filter?.searchType[0]?.key
          ? filter?.searchType[0]?.key
          : ""
        : selectedValue
        ? selectedValue
        : "",
      statusId:
        parseInt(tabvalue) === 0 ? 2 : parseInt(tabvalue) === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: ORG_ID(),
      organisationId: ORG_ID(),
      status: tabvalue ? tabvalue : "",
    };
    handleSearch(data);
    //   setPage(1);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  return (
    <>
      <Box className="filterResult">
        <div className="checkboxWrap">
          <FormGroup className="labelList">
            {isFilterTypeList ? (
              <>
                {filterType &&
                  filterType.map((item) => (
                    <FormControlLabel
                      key={item.key}
                      control={
                        <img
                          className="filterCheckbox"
                          title={
                            filter.searchType[0]?.key === item.key
                              ? "tickCheckbox"
                              : "untickCheckbox"
                          }
                          alt=""
                          src={
                            filter.searchType[0]?.key === item.key
                              ? commonImages.check
                              : commonImages.noCheck
                          }
                          onClick={() => onChangeType(item)}
                        />
                      }
                      label={item?.value}
                      className="checkboxText"
                    />
                  ))}
              </>
            ) : (
              <>
                {statusCheckbox && (
                  <Grid mb={2}>
                    <FormControl fullWidth>
                      <FormLabels label={"Category Status"} />
                      <div className="customSelectMethod">
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={activeInActive[ACTIVE_INACTIVE.ACTIVE]}
                                onChange={(event) =>
                                  handleActiveInActiveChange(event)
                                }
                                value={ACTIVE_INACTIVE.ACTIVE}
                                label="Active"
                              />
                            }
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  activeInActive[ACTIVE_INACTIVE.INACTIVE]
                                }
                                onChange={(event) =>
                                  handleActiveInActiveChange(event)
                                }
                                value={ACTIVE_INACTIVE.INACTIVE}
                                label={"InActive"}
                              />
                            }
                          />
                        </div>
                      </div>
                    </FormControl>
                  </Grid>
                )}
                <Grid md={12}>
                  <div className="filterTitle">Category</div>
                  <SelectMenu
                    name="Please select"
                    listData={filterType ?? []}
                    onchangehandler={(e) => onChangeType(e.target.value)}
                    value={selectedValue}
                    placeholder="Please select"
                  />
                </Grid>
              </>
            )}
          </FormGroup>
        </div>
        <div className="filterBottom">
          <CardActions>
            <Buttons
              primary={true}
              label={"Reset"}
              onClick={(e) => handleClear(e)}
              size="small"
            />
            <Buttons
              primary={true}
              label={"Apply"}
              onClick={(e) => handleApply(e)}
              size="small"
            />
          </CardActions>
        </div>
      </Box>
    </>
  );
};

export default LmsFilterList;
